import { AiFillBank } from 'react-icons/ai';

import { COMPANY, CurrentAccountModel } from 'models/company.model';
import { CATEGORY_TYPE } from 'models/documents.model';
import { COLOR } from 'styles/styledComponents/color.model';

import { ReactComponent as BatteryPack } from './assets/category/battery-pack.svg';
import { ReactComponent as BatteryIcon } from './assets/category/battery.svg';
import { ReactComponent as ConstructionIcon } from './assets/category/construction.svg';
import { ReactComponent as EarthIcon } from './assets/category/earth.svg';
import { ReactComponent as PreviewIcon } from './assets/category/preview.svg';
import { ReactComponent as RecycleIcon } from './assets/category/recycle.svg';
import { ReactComponent as ScienceIcon } from './assets/category/science.svg';
import { ReactComponent as ThrashIcon } from './assets/category/trash.svg';

export const getConfig = (company: COMPANY): CurrentAccountModel => {
  const isProduction = process.env.NODE_ENV === 'production';

  const setClientParams = (baseUrlEnvName: string, publisherIdEnvName: string) => {
    let finalBaseUrlEnvName = 'REACT_APP_DEV_BASE_URL';
    let finalPublisherIdEnvName = 'REACT_APP_DEV_PUBLISHER_ID';

    if (isProduction) {
      finalBaseUrlEnvName = baseUrlEnvName;
      finalPublisherIdEnvName = publisherIdEnvName;
    }

    const baseUrl = process.env[finalBaseUrlEnvName];
    const publisherId = process.env[finalPublisherIdEnvName];

    if (!baseUrl || !publisherId) {
      throw new Error(
        `The following env variable are missing: ${[
          finalBaseUrlEnvName,
          finalPublisherIdEnvName,
        ].reduce<string>((prev, next) => {
          if (!process.env[next]) {
            prev += `${!!prev.length ? ', ' : ''}${next}`;
          }
          return prev;
        }, '')}`
      );
    }

    return {
      baseUrl,
      publisherId,
    };
  };

  switch (company) {
    case COMPANY.CHEMISTRY:
      return {
        name: 'Chemistry Company',
        company,
        category: CATEGORY_TYPE.CHEMISTRY,
        subCategories: [CATEGORY_TYPE.CHEMISTRY_TEST_RESULTS],
        Icon: ScienceIcon,
        color: COLOR.CHEMISTRY,
        ...setClientParams('REACT_APP_CHEMISTRY_BASE_URL', 'REACT_APP_CHEMISTRY_PUBLISHER_ID'),
        isActive: true,
      };
    case COMPANY.BATTERY_CELLS:
      return {
        name: 'Battery Cells Company',
        company,
        category: CATEGORY_TYPE.BATTERY_CELLS,
        subCategories: [
          CATEGORY_TYPE.BATTERY_CELLS_TEST_RESULTS,
          CATEGORY_TYPE.BATTERY_CELLS_SHIPPING_CONFIRMATION,
        ],
        Icon: BatteryIcon,
        color: COLOR.BATTERY_CELLS,
        ...setClientParams(
          'REACT_APP_BATTERY_CELLS_BASE_URL',
          'REACT_APP_BATTERY_CELLS_PUBLISHER_ID'
        ),
        isActive: true,
      };
    case COMPANY.BATTERY_PACKS:
      return {
        name: 'Battery Packs Company',
        company,
        category: CATEGORY_TYPE.BATTERY_PACKS,
        subCategories: [
          CATEGORY_TYPE.BATTERY_PACKS_TEST_RESULTS,
          CATEGORY_TYPE.BATTERY_CELLS_RECEIVING_CONFIRMATION,
          CATEGORY_TYPE.CAR_DEALERS_SHIPPING_CONFIRMATION,
        ],
        Icon: BatteryPack,
        color: COLOR.BATTERY_PACKS,
        ...setClientParams(
          'REACT_APP_BATTERY_PACKS_BASE_URL',
          'REACT_APP_BATTERY_PACKS_PUBLISHER_ID'
        ),
        isActive: true,
      };
    case COMPANY.BATTERY_TECH_REVIEW:
      return {
        name: 'Batteries Tech Review Company',
        company,
        category: CATEGORY_TYPE.BATTERY_TECH_REVIEW,
        Icon: PreviewIcon,
        color: COLOR.BATTERY_TECH_REVIEW,
        ...setClientParams(
          'REACT_APP_BATTERY_TECH_REVIEW_BASE_URL',
          'REACT_APP_BATTERY_TECH_REVIEW_PUBLISHER_ID'
        ),
        isActive: true,
      };
    case COMPANY.BATTERY_PACKS_REPAIR:
      return {
        name: 'Battery Packs Repair Company',
        company,
        category: CATEGORY_TYPE.BATTERY_PACKS_REPAIR,
        Icon: ConstructionIcon,
        color: COLOR.BATTERY_PACKS_REPAIR,
        ...setClientParams(
          'REACT_APP_BATTERY_PACKS_REPAIR_BASE_URL',
          'REACT_APP_BATTERY_PACKS_REPAIR_PUBLISHER_ID'
        ),
        isActive: false,
      };
    case COMPANY.BATTERY_REPURPOSE:
      return {
        name: 'Battery Repurpose Company',
        company,
        category: CATEGORY_TYPE.BATTERY_REPURPOSE,
        Icon: RecycleIcon,
        color: COLOR.BATTERY_REPURPOSE,
        ...setClientParams(
          'REACT_APP_BATTERY_REPURPOSE_BASE_URL',
          'REACT_APP_BATTERY_REPURPOSE_PUBLISHER_ID'
        ),
        isActive: false,
      };
    case COMPANY.BATTERY_PACKS_RECYCLING:
      return {
        name: 'Battery Packs Recycling Company',
        company,
        category: CATEGORY_TYPE.BATTERY_PACKS_RECYCLING,
        Icon: EarthIcon,
        color: COLOR.BATTERY_PACKS_RECYCLING,
        ...setClientParams(
          'REACT_APP_BATTERY_PACKS_RECYCLING_BASE_URL',
          'REACT_APP_BATTERY_PACKS_RECYCLING_PUBLISHER_ID'
        ),
        isActive: false,
      };
    case COMPANY.BATTERY_WASTE:
      return {
        name: 'Battery Waste Company',
        company,
        category: CATEGORY_TYPE.BATTERY_WASTE,
        Icon: ThrashIcon,
        color: COLOR.BATTERY_WASTE,
        ...setClientParams(
          'REACT_APP_BATTERY_WASTE_BASE_URL',
          'REACT_APP_BATTERY_WASTE_PUBLISHER_ID'
        ),
        isActive: false,
      };
    case COMPANY.AUTHORITIES:
      return {
        name: 'Authorities',
        company,
        Icon: AiFillBank,
        color: COLOR.MID_GREY,
        ...setClientParams('REACT_APP_AUTHORITIES_BASE_URL', 'REACT_APP_AUTHORITIES_PUBLISHER_ID'),
        isActive: true,
      };
  }
};
